"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _MediaPlaybackController = require("./MediaPlaybackController");
Object.keys(_MediaPlaybackController).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MediaPlaybackController[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _MediaPlaybackController[key];
    }
  });
});